// extracted by mini-css-extract-plugin
module.exports = {"highlighthumb":"highlightThumb_highlighthumb__34wRk","value":"highlightThumb_value__1KHCS","bigFont":"highlightThumb_bigFont__3up-c","details":"highlightThumb_details__2HMbf"};